import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import tlBG from "../../assets/images/gradientBg.png";
import {
	WeddingCardContainer,
	WeddingCardDetail,
	WeddingCardImage,
	WeddingCardWrapper,
	WeddingDate,
} from "./component";
import { ReactComponent as Pin } from "../../assets/svg/map-pin.svg";
import { ReactComponent as Lock } from "../../assets/svg/lock_red.svg";
import dayjs from "dayjs";
import WeddingDetails from "../WeddingDetails/WeddingDetails";
import { Divider, Input, Modal } from "antd";
import { ButtonTab } from "../WeddingDetails/component";
import { inputStyle } from "../../lib/styles/styleLibrary";
import { Toast } from "../../lib/helpers/helpers";
import { useEnterWedding } from "../../redux/api/WeddingAPI";
import { Loading } from "../Loading/Loading";

const WeddingCard = ({
	background,
	date,
	name,
	location,
	details,
	handleClick = () => {
		return null;
	},
}) => {
	const [weddingDetails, setWeddingDetails] = useState(false);
	const [showProtected, setShowProtected] = useState(false);
	const [eventCode, setEventCode] = useState("");
	const { mutateAsync, isLoading } = useEnterWedding();

	const handleEnterWedding = async (code) => {
		const data = {
			code: eventCode || code,
		};
		try {
			const res = await mutateAsync({ data });
			console.log(res);
			const { hasError } = res;
			if (hasError) {
				return Toast.fire({
					icon: "error",
					title: res.message,
				});
			}
			setWeddingDetails(true);
			return Toast.fire({
				icon: "success",
				title: res.message,
			});
		} catch (error) {
			console.log(error);
		}
	};
	return (
		<WeddingCardContainer>
			<WeddingCardWrapper
				onClick={() => {
					details.is_protected
						? setShowProtected(true)
						: setWeddingDetails(true);
				}}>
				<div tw="h-full w-full flex flex-col gap-2">
					<WeddingCardImage
						preview={false}
						src={background || tlBG}
						alt={name}
						tw="rounded-lg"
						placeholder={
							<WeddingCardImage
								preview={false}
								src={background || tlBG}
							/>
						}
					/>
					<WeddingCardDetail>
						<WeddingDate>
							<span tw="text-appPinkSaturated text-base font-bold uppercase m-0!">
								{dayjs(date).format("MMM")}
							</span>
							<span tw="text-black! text-lg font-bold uppercase m-0!">
								{dayjs(date).format("DD")}
							</span>
						</WeddingDate>
						<div tw="h-full w-full flex flex-col justify-center gap-1">
							<span tw="text-black opacity-70 text-base font-bold capitalize m-0! w-full!">
								{name}
							</span>
							<div tw="text-black! opacity-40 text-lg text-sm m-0!">
								<Pin color="gray" />
								<span tw="text-black! opacity-70 ml-2!">
									{location}
								</span>
							</div>
						</div>
					</WeddingCardDetail>
				</div>
			</WeddingCardWrapper>
			<Modal
				footer=""
				visible={weddingDetails}
				centered
				bodyStyle={{ padding: 0 }}
				destroyOnClose={true}
				show
				closable={false}
				maskClosable={false}>
				<WeddingDetails
					handleBackButton={() => setWeddingDetails(false)}
					handleJoinEvent={(v) => handleEnterWedding(v)}
					setEventCode={() => setEventCode()}
					details={details}
				/>
			</Modal>
			<Modal
				footer=""
				visible={showProtected}
				centered
				bodyStyle={{ padding: 0 }}
				destroyOnClose={true}
				show
				closable={false}
				maskClosable={false}>
				<div tw="p-4 flex flex-col items-center gap-3">
					<h4 tw="font-bold text-appPurpleBlue m-0! text-base">
						{name}
					</h4>
					<h2 tw="font-bold text-center text-appPinkSaturated text-lg uppercase m-0!">
						<Lock tw="mr-2" />
						This event is private
					</h2>
					<Divider tw="m-0!" />

					<label>Enter Event Code to continue</label>
					<Input
						placeholder="Enter event code"
						value={eventCode}
						onChange={(e) => {
							setEventCode(e.target.value);
						}}
						css={inputStyle}
						maxLength={5}
						tw="w-7/12"
					/>
					<ButtonTab
						onClick={() => {
							eventCode.toLocaleLowerCase() ===
							details.event_code.toLocaleLowerCase()
								? handleEnterWedding()
								: Toast.fire({
										icon: "error",
										title: "Invalid code\nYou are not allowed to view this event",
								  });
						}}>
						{isLoading ? <Loading /> : "Enter"}
					</ButtonTab>
				</div>
			</Modal>
		</WeddingCardContainer>
	);
};

export default WeddingCard;
